/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PreInitSettingsService } from '../../core/services/settings/pre-init-setting.service';

@Injectable({
  providedIn: 'root'
})

export class CPRCouponModalService {
  middlewareUrl: string;
  accountPath: string;
  sfSite: string;
  sfProvider: string;
  constructor(
    private http: HttpClient,
    private preInitSettingsService: PreInitSettingsService,
  ) {
    this.middlewareUrl = this.preInitSettingsService.getSettings().middleWare.middlewareUrl;
    this.accountPath = this.preInitSettingsService.getSettings().middleWare.accountPath;
    this.sfSite = this.preInitSettingsService.getSiteSettings().id;
    this.sfProvider = this.preInitSettingsService.getSiteSettings().provider;
  }

}
